import { render, staticRenderFns } from "./SpecialistBanListTable.vue?vue&type=template&id=c246bcfc&scoped=true&"
import script from "./SpecialistBanListTable.vue?vue&type=script&lang=js&"
export * from "./SpecialistBanListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c246bcfc",
  null
  
)

export default component.exports